// components/ui/drink-categories.jsx
import React from "react";
import { Card } from "@/components/ui/card";

const DrinkCategories = ({
  categories,
  onSelectSubcategory,
  selectedSubcategory,
}) => {
  console.log("[DrinkCategories] Render with:", {
    categories,
    selectedSubcategory,
  });

  if (!categories || categories.length === 0) {
    return (
      <div className="p-4 text-center text-gray-500">
        No hay categorías disponibles
      </div>
    );
  }

  const handleCategoryClick = (category) => {
    console.log("[DrinkCategories] Category clicked:", category);
    if (category && category._id) {
      console.log(
        "[DrinkCategories] Calling onSelectSubcategory with:",
        category._id
      );
      onSelectSubcategory(category._id);
    }
  };

  return (
    <div className="overflow-x-auto pb-4 hide-scrollbar">
      <div className="flex gap-4 px-4 min-w-max">
        {categories.map((category) => (
          <div key={category._id} className="w-32">
            <Card
              className={`h-32 flex flex-col items-center justify-center p-4 cursor-pointer transition-colors ${
                selectedSubcategory === category._id
                  ? "bg-orange-500 text-white"
                  : "bg-white hover:bg-orange-50"
              }`}
              onClick={() => handleCategoryClick(category)}
            >
              <div
                className={
                  selectedSubcategory === category._id
                    ? "text-white"
                    : "text-orange-500"
                }
              >
                <svg
                  viewBox="0 0 24 24"
                  className="w-8 h-8"
                  fill="currentColor"
                >
                  <path d="M7 2h10l3 8v10c0 1.1-.9 2-2 2H6c-1.1 0-2-.9-2-2V10l3-8zm2.2 2L7 10h10l-2.2-6H9.2z" />
                </svg>
              </div>
              <span className="text-sm font-medium text-center mt-2 whitespace-pre-line">
                {category.name}
              </span>
            </Card>
          </div>
        ))}
      </div>
    </div>
  );
};

export default DrinkCategories;
